import React, { useEffect, useState } from 'react'

// third party
import { Link } from 'react-router-dom'
import Pagination from "react-js-pagination";
import { useSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
// utils
import { successMessage, errorMessage } from "../utils/toastMessage"
import { paginate } from '../utils/paginate'
//components
import Overlay from "../component/overlay/overlay"
import PageUrlGuid from '../component/pageUrlGuid';
import Footer from '../component/footer';
import Header from '../component/header';
import Seperator from '../component/seperator';
//redux
import { changeState } from '../redux/loading';
//services
import { books } from '../service/journalService'



const Books = () => {
    //=========================================================== use hooks 
    const dispatch = useDispatch()

    const [getProducts, setProducts] = useState([])
    const [getTags, setTags] = useState([])
    const [getCategories, setCategories] = useState([])

    const [getSearchOverlay, setSearchOverlay] = useState(false)
    const [getCategoryOverlay, setCategoryOverlay] = useState(false)

    const [getSearchParams, setSearchParams] = useSearchParams();



    const pageParams = getSearchParams.get("page") == null ? 1 : parseInt(getSearchParams.get("page"))
    const filterParams = getSearchParams.get("filter") == null ? "id" : getSearchParams.get("filter")
    const searchParams = getSearchParams.get("search") == null ? "" : getSearchParams.get("search")
    const categoryParams = getSearchParams.get("category") == null ? "" : getSearchParams.get("category")

    //=========================================================== backend function
    const handleGetProducts = async () => {
        dispatch(changeState(true))
        try {
            const { status, data } = await books();
            if (status === 200) {
                setProducts(data.data)
            }

        } catch (ex) {
            errorMessage("مشکلی از سمت سرور پیش آمده")
        }

    }
    const handleGetTags = async () => {
        try {
            const { status, data } = await books();
            if (status === 200) {
                setTags(data.tags)
            }

        } catch (ex) {
            errorMessage("مشکلی از سمت سرور پیش آمده")
        }

    }
    const handleGetCategories = async () => {
        try {
            const { status, data } = await books();
            if (status === 200) {
                setCategories(data.categories)
                dispatch(changeState(false))
            }

        } catch (ex) {
            errorMessage("مشکلی از سمت سرور پیش آمده")
            dispatch(changeState(false))
        }

    }
    //=========================================================== frontend operations
    // ======= category
    var categoryFilter = []
    if (categoryParams == "" || getProducts.length == 0) {
        categoryFilter = [...getProducts]
    }
    else {
        const categoryParamsId = getCategories.filter(category => category['title'] == categoryParams)[0]["id"]
        categoryFilter = [...getProducts].filter(product => product["category"].includes(categoryParamsId))

    }
    // ======= search
    var searchFilter = []
    if (searchParams == "" || getCategories.length == 0) {
        searchFilter = [...getProducts]
    }
    else {
        const searchParamsTags = getTags.filter(tag => tag['title'].indexOf(searchParams) > -1)
        for (var i = 0; i < searchParamsTags.length; i++) {
            searchFilter.push(...[...getProducts].filter(product => product.tag.indexOf(searchParamsTags[i].id) > -1))
        }
    }
    // ======= merge category and search
    let categoryAndSearch = categoryFilter.filter(x => searchFilter.includes(x));
    // ======= filter
    var productsOrder = []
    if (filterParams == "") {
        productsOrder = [...categoryAndSearch].sort((a, b) => (a.id > b.id) ? 1 : -1)
    }
    else {
        productsOrder = [...categoryAndSearch].sort((a, b) => (a[filterParams] < b[filterParams]) ? 1 : -1)
    }
    // ======= pagination
    const indexCourses = paginate(productsOrder, pageParams, 4);
    //=========================================================== frontend function
    const hanldeChangeParams = ({ page = 1, filter = filterParams, search = searchParams, category = categoryParams } = {}) => {
        setSearchParams({ "page": page, "filter": filter, "search": search, "category": category })
    }
    //=========================================================== use effect
    useEffect(() => {
        handleGetProducts()
        handleGetTags()
        handleGetCategories()
    }, [])




    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    کتاب ها
                </h1>
            </PageUrlGuid>

            <div className='products'>
                <div className='filter'>
                    <div className='search'>
                        <input type="text" placeholder='چی دوس داری یاد بگیری' value={searchParams} onChange={(e) => hanldeChangeParams({ search: e.target.value })} />
                        <i className='fa fa-search'></i>
                    </div>
                    <div className='category'>
                        <h2 className={`${categoryParams == "" ? "active" : ""}`} onClick={(e) => hanldeChangeParams({ category: "" })}>
                            <i className='fa fa-car'></i>
                            <span>همه</span>
                        </h2>
                        {getCategories.map(
                            category => (
                                <div key={category.id}>
                                    <hr />
                                    <h2 className={`${categoryParams == category.title ? "active" : ""}`} onClick={(e) => hanldeChangeParams({ category: category.title })}>
                                        <i style={{ color: category.colorName }} className={category.iconName}></i>
                                        <span>{category.title}</span>
                                    </h2>
                                </div>
                            )
                        )}
                    </div>
                </div>
                <div className='content'>
                    <div className='show-order'>
                        <div className='order'>
                            <i className='fas fa-align-right' onClick={() => { setCategoryOverlay(true) }} ></i>

                            <i className='fa fa-search' onClick={() => { setSearchOverlay(true) }}></i>
                        </div>
                        <div className='counter'>   {productsOrder.length}  نشریه </div>
                    </div>
                    <hr />
                    <div className='products-list'>

                        {indexCourses.map(
                            product => (
                                <div key={product.id} className='product'>
                                    <Link to={`/books/${product.slug}`}>
                                        <img src={product.image} alt="" />
                                        <i className='fa fa-ellipsis-h more-icon'></i>
                                        <div className='informations'>
                                            <h2 className='title'>{product.title}</h2>
                                            {/* <div className="price"> {product.price} هزار تومان </div> */}
                                        </div>
                                    </Link>

                                </div>
                            )
                        )}

                    </div>
                    <Pagination
                        activePage={pageParams}
                        itemsCountPerPage={4}
                        totalItemsCount={productsOrder.length}
                        pageRangeDisplayed={5}
                        hideDisabled={true}
                        prevPageText={<i className='fas fa-angle-left'></i>}
                        nextPageText={<i className='fas fa-angle-right'></i>}
                        lastPageText={<i className='fas fa-angle-double-right'></i>}
                        firstPageText={<i className='fas fa-angle-double-left'></i>}
                        onChange={(e) => hanldeChangeParams({ page: e })}
                    />
                </div>

                {/* =========================================================== addon codes  */}
                {
                    getSearchOverlay ?
                        <Overlay stateName={setSearchOverlay}  >
                            <div className='mobile-overlay-title search'>
                                <span>جستجو</span>
                                <span>{productsOrder.length} کتاب</span>
                            </div>
                            <hr />
                            <div className='categories-mobile search'>
                                <input placeholder='چی دوس داری یاد بگیری' value={searchParams} onChange={(e) => hanldeChangeParams({ search: e.target.value })} type="text" />
                                <i className='fa fa-search'></i>
                            </div>
                        </Overlay>
                        : null
                }
                {
                    getCategoryOverlay
                        ?
                        <Overlay stateName={setCategoryOverlay}>
                            <div className='mobile-overlay-title category'>
                                <span>دسته بندی</span>
                                <span>{productsOrder.length} کتاب</span>
                            </div>
                            <hr />
                            <div className='categories-mobile category'>
                                <h2 className={`category-mobile ${categoryParams == "" ? "active" : null}`} onClick={() => hanldeChangeParams({ category: "" })}>
                                    <span>همه</span>
                                    {/* {categoryParams == "" ? (<i className='fa fa-check'></i>) : null} */}
                                </h2>

                                {getCategories.map(category => (
                                    <div key={category.id}>
                                        <hr />
                                        <h2 className={`category-mobile ${categoryParams == category.title ? "active" : null}`} onClick={() => hanldeChangeParams({ category: category.title })}>
                                            <span>
                                                <i style={{ color: category.color }} className={category.icon}></i>
                                                {category.title}
                                            </span>
                                        </h2>

                                    </div>
                                ))}
                            </div>
                        </Overlay>
                        : null
                }
            </div>
        </>
    )
}


export default Books